<template>
  <v-row class="pa-5" v-if="doc">
    <v-col cols="11">
      <v-row dense>
        <v-col cols="12">
          <h2 v-if="doc.title">{{ doc.title }}</h2>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" class="mt-5 mb-5">
          <h3>Audience Messages</h3>
        </v-col>
        <v-col cols="12" v-for="item in audienceQuestions" :key="item.model">
          <v-row>
            <v-col cols="3">
              <p class="">
                {{ item.title }}
              </p>
            </v-col>
            <v-col cols="9">
              <div v-for="(el, index) in getRow(item.model, 'audience')" :key="`${key}-inner-${index}`" class="">
                <p class="list-item">{{ el.title }}</p>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>


      <v-row>
        <v-col cols="12" class="mt-5 mb-5">
          <h3>Content</h3>
        </v-col>
        <v-col cols="12" v-for="item in contentQuestions" :key="item.model">
          <v-row>
            <v-col cols="3">
              <p class="">
                {{ item.title }}
              </p>
            </v-col>
            <v-col cols="9">
              <div v-for="(el, index) in getRow(item.model, 'content')" :key="`${key}-inner-${index}`" class="">
                <p class="list-item">{{ el.title }}</p>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

    </v-col>
  </v-row>
</template>

<script>
// import lodash from "lodash";

import { mapState } from "vuex";

export default {
  name: "ResultsArhitectureSummary",
  props: {
    doc: Object,
    audienceQuestions: {
      type: Array,
      default: () => [],
    },
    contentQuestions: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },
  methods: {
    getRow(item, model) {
      // expects audience.q1
      const key = item.substr(9)
      // return key // 'q1'
      const row = this.doc[model]?.[key]
      return row
    }
  }
};
</script>

<style lang="scss" scoped>
.list-item {
  border-bottom: dotted 1px rgba(0, 0, 0, 0.5);
  margin: 0;
  padding: 5px 0;
}
</style>
